import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import GiftCardWorking from "../DASHBOARD/GiftCardWorking";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import useMediaQuery from "@mui/material/useMediaQuery";
import { v4 as uuidv4 } from "uuid";

import {
  List,
  ListItem,
  ListItemText,

} from "@mui/material";
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import { useLocation } from "react-router";
import { Helmet } from "react-helmet-async";


const GiftCardWorks = (props) => {
  const { isMobile = false } = props;
  const Mobile = useMediaQuery("(max-width:480px)");
  const backgroundColor = Mobile ? "#fff" : "white.main";
  const location = useLocation();
  const canonicalUrl = `https://www.99gift.ae${location.pathname}`;

  const giftCardContiner = {
    boxShadow: { xs: 0, sm: 1, md: 2 },
    borderRadius: { xs: 0, sm: 1, md: 3 },
    p: { xs: 0, sm: 2, md: 3 },
    my: { xs: 2, sm: 3, md: 3 },
    backgroundColor: backgroundColor,
  };

  const giftCardStyle = {
    my: { xs: 0, md: 0 },
  };
   useEffect(()=>{
          window.scrollTo(0, 0);
    },[])
  return (
    <React.Fragment>
      <Helmet>
        <title>How Gift Cards Works - 99Gift</title>
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content="How Gift Cards Works - 99Gift" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {!isMobile &&
        (
          <Container maxWidth="xl">
            <PageBreadcrumb
              home="Home"
              currentProduct="How Gift Cards Works"
            />
          </Container>
        )
      }

      <Container
        maxWidth="false"
        disableGutters={true}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#F1F5F6",
          "@media (max-width:480px)": {
            backgroundColor: "white.main",
          },
        }}
      >
        <GiftCardWorking style={giftCardStyle} />
        <Grid
          container
          alignItems="center"
          maxWidth="lg"
          sx={{
            px: { xs: 2, md: 0 },
            justifyContent: "center"
          }}
        >

          <Grid item xs={12}>
            <GiftCardAdvantage giftCardContiner={giftCardContiner} />
            <GiftCardDiscount giftCardContiner={giftCardContiner} />
            <GiftCategoryDiscount giftCardContiner={giftCardContiner} />
            <GiftCategoryBuy giftCardContiner={giftCardContiner} />
            <GiftCardValidity giftCardContiner={giftCardContiner} />
            <GiftCardPhysical giftCardContiner={giftCardContiner} />
            <GiftCardShare giftCardContiner={giftCardContiner} />
            <GiftCardDigital giftCardContiner={giftCardContiner} />
            <GiftCardWhychooseDigital giftCardContiner={giftCardContiner} />
            <GiftCardGetReady giftCardContiner={giftCardContiner} />
          </Grid>
        </Grid>
      </Container>

    </React.Fragment>
  );
};

GiftCardWorks.propTypes = {};

export default GiftCardWorks;

function GiftTitle({ param1, param2 }) {
  return (
    <React.Fragment>
      {param1 && (
        <Typography
          variant="h3"
          color="priimary.main"
          sx={{
            display: "inline-block",
            fontSize: { xs: "14.5px", md: "18px" },
          }}
        >
          {param1}
        </Typography>
      )}
      {param2 && (
        <Typography
          variant="h3"
          color="secondary.main"
          sx={{
            display: "inline-block",
            ml: { xs: "2px", md: "3px" },
            fontSize: { xs: "14.5px", md: "18px" },
          }}
        >
          {param2}
        </Typography>
      )}
    </React.Fragment>
  );
}



function GiftCardAdvantage({ giftCardContiner }) {
  const orders = [
    {
      content:
        "At 99gift.ae, we make gifting simple with digital gift cards that are easy to buy, deliver, and redeem. Whether you want to send a thoughtful gift to someone special or reward your team for their hard work, gift cards are one of the most flexible and convenient gifting options in the UAE.",
    },
    {
      content: "In this guide, we walk you through how gift cards work, from purchase to redemption, and explain why they are perfect for today’s digital lifestyle."
    }

  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="How Gift " param2="Cards Work" />
        </Grid>

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={uuidv4()} dense sx={{ pl: "0" }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {order?.icon}
                  </ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    // primary={`${}.`}
                    primaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",

                      mr: { xs: "3px", md: "3px" },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function GiftCardDiscount({ giftCardContiner }) {
  const orders = [
    {
      content:
        "A digital gift card — also known as an e-gift card or online gift card — is an electronic version of a traditional gift card that carries a prepaid value. Instead of receiving a physical card, the recipient gets a unique gift card code via email, which they can use to make purchases either online or in-store according to the brand’s terms.",
    },
    {
      content:
        "Digital gift cards are fast, secure, and eliminate the need for plastic cards, making them perfect for last-minute or remote gifting. ",
    },


  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="What Is a Digital " param2="Gift Cards?" />
        </Grid>



        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={uuidv4()} dense sx={{ pl: "0" }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {order?.icon}
                  </ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText

                    primaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",

                      mr: { xs: "3px", md: "3px" },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>


      </Grid>
    </React.Fragment>
  );
}

function GiftCategoryDiscount({ giftCardContiner }) {
  const orders = [
    {

      content:
        "•	Shopping, fashion, and lifestyle",
    },
    {

      content:
        "•	Dining and restaurants"
    },
    {

      content:
        "•	Entertainment and experiences"
    },
    {

      content:
        "•	Electronics and gaming",
    },
    {

      content:
        "•	Travel and more",
    },
    {

      content:
        "Each card displays details like value, brand, and redemption instructions to help you select the perfect gift.",
    },

  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="Step-by-Step: How Gift Cards Work on " param2="99 Gift" />
        </Grid>

        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 3, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "15px", md: "16px" } }}
          >
            Choose Your Gift Card:
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 3, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            Browse our selection of gift cards and choose the one that best fits your needs. You can find cards for:
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={uuidv4()} dense sx={{ pl: "0" }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {order?.icon}
                  </ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText

                    primaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "17px" },
                      color: "primary.main",
                      fontWeight: { xs: 600, md: 600 },
                      display: "inline",

                      mr: { xs: "3px", md: "3px" },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function GiftCategoryBuy({ giftCardContiner }) {
  const orders = [
    {
      content: "Decide how much value you want to load onto the gift card. All amounts are shown in AED (United Arab Emirates Dirham) for full transparency and convenience.",
    },



  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="Select the " param2="Card Amount" />
        </Grid>
        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={uuidv4()} dense sx={{ pl: "0" }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {order?.icon}
                  </ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText

                    primaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",

                      mr: { xs: "3px", md: "3px" },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* <Grid item xs={12} sx={{ mb: 0, mt: { xs: 0, md: 1 } }}>
          <Typography
            variant="subtitle2"
            color="primary.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            In a few minutes, we will drop your voucher to your SMS and/or email
            inbox. Isn’t it so simple?
          </Typography>
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}

function GiftCardValidity({ giftCardContiner }) {
  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle
            param1="Pay"
            param2=" Securely Online"
          />
        </Grid>

        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px", } }}
          >
            Make your payment using secure online payment options available on our website. At 99gift, we use trusted and encrypted payment systems to protect your details and ensure a safe checkout experience.
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function GiftCardPhysical({ giftCardContiner }) {
  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="Instant" param2="Digital Delivery" />
        </Grid>

        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            Once your payment is successfully processed, the gift card is sent instantly to the email address you provide — whether it’s your own or the recipient’s. Delivery via email means there’s no waiting, no shipping cost, and no physical card to lose.
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function GiftCardShare({ giftCardContiner }) {
  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle
            param1="Redeem and "
            param2="Enjoy"
          />
        </Grid>

        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            The recipient simply opens the email, views the unique gift card code, and follows the redemption instructions. Depending on the brand’s terms, gift cards can be used to:
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            •	Make purchases on the brand’s online store<br />
            •  Enter the code at checkout for in-store transactions (if supported)<br />
            •	Apply the gift card value toward products or services<br />


          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            This flexibility makes digital gift cards ideal for a wide variety of shopping experiences.


          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}


function GiftCardDigital({ giftCardContiner }) {
  const orders = [
    {
      title: "Instant and Convenient",
      content:
        "Digital gift cards are delivered in seconds, so they’re perfect for surprise gifts, last-minute celebrations, and remote gifting.",
    },
    {
      title: "No Shipping Hassle",
      content:
        "There’s no physical delivery, which means you never have to worry about delays, lost packages, or additional costs.",
    },
    {
      title: "Safe and Secure",
      content:
        "Each gift card includes a unique code that can only be used once. Sensitive information is protected, and card details can’t be easily tampered with or duplicated.",
    },
    {
      title: "Flexible Use",
      content:
        "Depending on the issuer’s rules, the recipient can often use the whole card in one purchase or split it across multiple purchases until the balance is used",
    },
    {
      title: "Checking Gift Card Balance",
      content:
        "Many gift cards allow you or the recipient to check the remaining balance at any time — this may be done through the merchant’s website, mobile app, or at checkout during a purchase.",
    },
    {
      title: "Gift Card Validity and Terms",
      content:
        "Each gift card has an expiration date and specific conditions set by the issuing brand. Always check the detailed terms and conditions when purchasing a gift card so you know how long it is valid and where it can be redeemed.",
    },
    {

      content:
        "We provide clear information on validity periods and usage rules, but it’s also the recipient’s responsibility to manage and redeem their gift card before expiration",
    },


  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="Benefits of Using  " param2="Digital Gift Cards" />
        </Grid>

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={uuidv4()} dense sx={{ pl: "0" }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {order?.icon}
                  </ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    // primary={`${}.`}
                    primary={order?.title}
                    primaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",

                      mr: { xs: "3px", md: "3px" },
                    }}

                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
function GiftCardWhychooseDigital({ giftCardContiner }) {
  const orders = [
    {

      content:
        "Fast and instant email delivery across the UAE",
    },
    {

      content:
        "Secure online payments",
    },
    {

      content:
        "Clear AED pricing",
    },
    {

      content:
        "Helpful support for both personal and corporate gifting",
    },


  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle param1="Why Choose 99gift for Digital  " param2="Gift Cards?" />
        </Grid>

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={uuidv4()} dense sx={{ pl: "0" }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {order?.icon}
                  </ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    // primary={`${index + 1}.`}
                    primary={order?.title}
                    primaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",

                      mr: { xs: "3px", md: "3px" },
                    }}

                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: "13.5px", md: "16px" },
                      color: "dark.main",
                      fontWeight: { xs: 400, md: 300 },
                      display: "inline",
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            Our platform is designed to help you give meaningful, convenient gifts that bring joy to both giver and recipient.


          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function GiftCardGetReady({ giftCardContiner }) {
  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <GiftTitle
            param1="Get Started Today With"
            param2=" 99gift cards "
          />
        </Grid>

        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
          >
            Ready to send a thoughtful, flexible gift? Browse our collection and buy digital gift cards online in the UAE today at 99gift — the easy, secure, and modern way to gift!
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
